import { Tab, Tabs } from "@mui/material";
import { useEffect, useMemo } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useStudents } from "../../context/students";
import { useTranslate } from "../../hooks/useTranslate";
import { STUDENT_STATUS } from "../../constants/student.status";
import useStatuses from "../../context/status/useStatuses";
import "./StudentTabs.css";

const StudentTabs = (props) => {
    const { showAddStudentOnly } = props;

    const { pathname } = useLocation();
    const { studentId } = useParams();
    const navigate = useNavigate();
    const { t } = useTranslate();
    const { contact } = useStatuses();

    const isContactPrimary = contact?.contactType === "Primary";

    const { students, activeStudentId, onChangeActiveStudentId } = useStudents();

    const tabs = useMemo(() => (showAddStudentOnly ? [] : students
        .filter((student) => Object.values(STUDENT_STATUS).includes(student?.studentStatusCode))
        .map((student) => ({
            id: student.studentId, fullName: `${student.forename} ${student.surname}`,
        }))), [students, showAddStudentOnly]);

    const isInvoicePay = pathname.includes("finance/pay/");
    const isRenewalPay = pathname.includes("renewals/payment");
    const isAddStudent = pathname.endsWith("add-student/new");

    const onTabChange = (_, newValue) => {
        onChangeActiveStudentId(newValue === "new" ? undefined : newValue);

        if (newValue === "new") {
            navigate(`add-student/new?from=${pathname}`);
        } else if (isInvoicePay) {
            navigate(`finance/payments/${newValue}`);
        } else if (isRenewalPay) {
            navigate(`renewals/${newValue}`);
        } else {
            navigate(`${pathname.replace(`/${studentId}`, "")}/${newValue}`);
        }
    };

    useEffect(() => {
        if (showAddStudentOnly) return;
        if (!studentId && !!activeStudentId) {
            navigate(`${pathname.replace(`/${studentId}`, "")}/${activeStudentId}`);
        }
    }, [showAddStudentOnly, studentId, activeStudentId, pathname]);

    return (
        <Tabs
            value={isAddStudent ? "new" : activeStudentId}
            onChange={onTabChange}
            variant="scrollable"
            className="student-tabs"
        >
            {activeStudentId && tabs.map((item) => (
                <Tab
                    key={item.id}
                    value={item.id}
                    label={item.fullName}
                    id={`tab-${item.id}-${item.fullName}`}
                    aria-labelledby={`tabpanel-${item.id}-${item.fullName}`}
                    disableRipple
                    className="student-tabs__tab"
                />
            ))}
            {isContactPrimary && (
                <Tab
                    key="add-student"
                    value="new"
                    label={t("navigation.addStudent")}
                    id="tab-add-student"
                    aria-labelledby="tabpanel-add-student"
                    disableRipple
                    className="student-tabs__tab"
                />
            )}
        </Tabs>
    );
};

export default StudentTabs;
